import styled from 'styled-components'

export const LocationsWrapper = styled.div`
  position: relative;
  & > * {
    z-index: ${props => props.theme.zIndexes.cities.content};
  }
  &:after {
    content: '';
    position: fixed;
    width: 100%;
    height: 100%;
    background: ${props => props.theme.colors.white};
    left: 0;
    z-index: ${props => props.theme.zIndexes.cities.background};
  }

  .filters-wrapper {
    margin: 29px 0 0 0;

    .filter-box {
      .search-input {
        max-width: 285px;
      }

      .select-status {
        float: left;
        margin: 0 20px 0 0;

        div:nth-child(2) {
          width: 108px !important;
        }
      }

      .link-add {
        display: block;
        float: left;
      }
    }

    .filter-box:nth-child(1) {
      float: left;
    }

    .filter-box:nth-child(2) {
      float: right;
    }
  }

  table {
    th {
      height: 11px;

      &:last-child {
        padding-right: 65px;
      }
    }

    th:nth-child(1),
    td:nth-child(1) {
      padding-left: 50px;
    }

    td {
      &:last-child {
        position: relative;
        white-space: nowrap;
        padding-right: 65px;

        a,
        div {
          display: inline-block;
          position: relative;
          top: 2px;
          margin: 0 20px 0 0;

          svg {
            margin-right: 0;
          }
        }

        div:last-child {
          margin: 0;
        }
      }
    }
  }
`
